<!-- Breadcrumb -->
<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
    <h5 class="mb-0">
        {{ 'Update_inverter' | translate}}
    </h5>

    <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
        <li class="breadcrumb-item position-relative">
            <a routerLink="/plants/all-plant-list">{{ 'Plants_list' | translate}}</a>
        </li>

        <li class="breadcrumb-item position-relative">
            <a class="gap-icon" (click)="goPlantsDetails()">
                {{ 'Plant_details' | translate }}
            </a>
        </li>

        <li class="breadcrumb-item position-relative">
            {{'Update_inverter' | translate }}
        </li>
    </ol>
</div>

<mat-card class="daxa-card users-card mb-25 border-radius bg-white">
    <div *ngIf="loading">Loading...</div>
    <div *ngIf="!loading">
        <!-- Selected inverter -->
        <div *ngIf="inverters?.length" class="mb-20">
            <mat-form-field>
                <mat-label>{{"Selected inverter" | translate}}</mat-label>
                <input matInput [value]="selectedInverter?.serialNumber || selectedInverter?._serialNumber" readonly />
            </mat-form-field>
        </div>

        <form [formGroup]="invertersForm">
            <div class="row">

                <!-- Brand -->
                <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="mb-20">
                        <label class="main-label d-block lh-1 text-black">{{'Brand' | translate}}</label>
                        <mat-form-field class="w-full">
                            <mat-label>{{'Brand' | translate}}</mat-label>
                            <input type="text" matInput formControlName="brand" [matAutocomplete]="brandAuto"
                                [formControl]="brandSearchCtrl" placeholder="Type to search brand" />

                            <mat-autocomplete #brandAuto="matAutocomplete" (optionSelected)="onBrandSelected($event)">
                                <mat-option *ngFor="let b of (filteredBrands$ | async)" [value]="b">
                                    {{ b }}
                                </mat-option>
                            </mat-autocomplete>

                            <mat-error *ngIf="invertersForm.get('brand')?.hasError('required')">
                                {{ 'Brand_is_required' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Model -->
                <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="mb-20">
                        <label class="main-label d-block lh-1 text-black">{{'Model' | translate}}</label>
                        <mat-form-field class="w-full">
                            <mat-label>{{'Model' | translate}}</mat-label>
                            <input type="text" matInput formControlName="model" [matAutocomplete]="modelAuto"
                                [formControl]="modelSearchCtrl" placeholder="{{'Type to search model' | translate}}" />

                            <mat-autocomplete #modelAuto="matAutocomplete">
                                <mat-option *ngFor="let m of (filteredModels$ | async)" [value]="m">
                                    {{ m }}
                                </mat-option>
                                <mat-option disabled *ngIf="(filteredModels$ | async)?.length === 0">
                                    No results
                                </mat-option>
                            </mat-autocomplete>

                            <mat-error *ngIf="invertersForm.get('model')?.hasError('required')">
                                {{ 'Model_is_required' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Serial number -->
                <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="mb-20">
                        <label class="main-label d-block lh-1 text-black">{{'Serial_number' | translate}}</label>
                        <mat-form-field class="w-full">
                            <mat-label>{{'Serial_number' | translate}}</mat-label>
                            <input matInput formControlName="serialNumber" placeholder="e.g. ABC-123" />
                            <mat-error *ngIf="invertersForm.get('serialNumber')?.hasError('required')">
                                {{ 'Serial_number_is_required' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Max production capacity -->
                <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="mb-20">
                        <label class="main-label d-block lh-1 text-black">{{'Max_production_capacity_(kWh)' |
                            translate}}</label>
                        <mat-form-field class="w-full">
                            <mat-label>{{'Max_production_capacity_(kWh)' | translate}}</mat-label>
                            <input type="number" matInput formControlName="maxProductionCapacity"
                                placeholder="e.g. 5" />
                        </mat-form-field>
                    </div>
                </div>

                <!-- Total battery capacity -->
                <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="mb-20">
                        <label class="main-label d-block lh-1 text-black">{{'Total_battery_capacity_(kWh)'|
                            translate}}</label>
                        <mat-form-field class="w-full">
                            <mat-label>{{'Total_battery_capacity_(kWh)'| translate}}</mat-label>
                            <input type="number" matInput formControlName="totalBatteryCapacityKwhsolarPanels"
                                placeholder="e.g. 10" />
                            <mat-error
                                *ngIf="invertersForm.get('totalBatteryCapacityKwhsolarPanels')?.hasError('required')">
                                {{'Total battery capacity is required' | translate}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Battery charge power rate -->
                <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="mb-20">
                        <label class="main-label d-block lh-1 text-black">{{'Battery charge power rate (kW)' |
                            translate}}</label>
                        <mat-form-field class="w-full">
                            <mat-label>{{'Battery charge power rate (kW)' | translate}}</mat-label>
                            <input type="number" matInput formControlName="batteryChargePowerRateKw"
                                placeholder="e.g. 3" />
                            <mat-error *ngIf="invertersForm.get('batteryChargePowerRateKw')?.hasError('required')">
                                {{ 'Battery charge power rate is required' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <!-- Solar Threshold -->
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="mb-20">
                        <label class="main-label d-block lh-1 text-black">
                            {{ 'solar threshold' | translate }}
                        </label>

                        <mat-form-field class="w-full">
                            <mat-label>{{ 'solar threshold' | translate }}</mat-label>

                            <input matInput formControlName="solarFactorThreshold" placeholder="e.g. 0.2"
                                autocomplete="off" />

                            <mat-error *ngIf="invertersForm.controls.solarFactorThreshold.hasError('required')">
                                {{ 'solar_threshold_required' | translate }}
                            </mat-error>

                            <mat-error
                                *ngIf="invertersForm.controls.solarFactorThreshold.hasError('solarThresholdInvalid')">
                                {{ 'solar_threshold_invalid' | translate }}
                            </mat-error>

                            <mat-error
                                *ngIf="invertersForm.controls.solarFactorThreshold.hasError('solarThresholdOutOfRange')">
                                {{ 'solar_threshold_out_of_range' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <!-- Total panel power -->
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="mb-20">
                        <label class="main-label d-block lh-1 text-black">
                            {{'Total panel power (kWh)' | translate}}
                        </label>
                        <mat-form-field class="w-full">
                            <mat-label>{{'Total panel power (kWh)' | translate}}</mat-label>
                            <input type="number" matInput formControlName="totalPanelPowerKwh" placeholder="e.g. 3" />
                            <mat-error *ngIf="invertersForm.get('totalPanelPowerKwh')?.hasError('required')">
                                {{'Required' | translate}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Metering points -->
                <div class="col-lg-12 col-md-12 col-sm-12" formArrayName="meteringPoints">
                    <div class="mb-20">
                        <div class="flex items-center justify-between mb-10">
                            <label class="main-label d-block lh-1 text-black">{{'Metering_Points' | translate}}</label>

                            <button mat-stroked-button class="add-metring-point" color="primary" type="button"
                                (click)="addMeteringPoint()">
                                + {{'Add metering point' | translate}}
                            </button>
                        </div>

                        <div *ngFor="let row of meteringPointsFA.controls; let i = index" class="mp-row"
                            [formGroupName]="i">

                            <mat-form-field class="mp-field">
                                <mat-label>{{'Metering Point ID' | translate}}</mat-label>
                                <input matInput formControlName="meteringPointId" placeholder="e.g. 579" />
                                <mat-error *ngIf="row.get('meteringPointId')?.hasError('required')">
                                    {{'Required' | translate}}
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="mp-field">
                                <mat-label>{{'Meter Type' | translate}}</mat-label>
                                <input matInput type="text" formControlName="meterTypeSearch" [matAutocomplete]="mtAuto"
                                    placeholder="Search meter type" />

                                <mat-autocomplete #mtAuto="matAutocomplete"
                                    (optionSelected)="onMeterTypeSelected(i, $event)">
                                    <mat-option *ngFor="let mt of (getMeterTypeFiltered(i) | async)" [value]="mt.title">
                                        {{ mt.title }} <span *ngIf="mt.description"> - {{ mt.description }}</span>
                                    </mat-option>
                                    <mat-option disabled *ngIf="(getMeterTypeFiltered(i) | async)?.length === 0">
                                        No results
                                    </mat-option>
                                </mat-autocomplete>

                                <mat-error *ngIf="row.get('meterType')?.hasError('required')">
                                    Required
                                </mat-error>
                            </mat-form-field>

                            <div class="mp-main">
                                <mat-checkbox formControlName="isMain" (change)="setAsMain(i)">{{'Main' |
                                    translate}}</mat-checkbox>
                            </div>

                            <div class="mp-remove">
                                <button mat-icon-button color="warn" type="button" (click)="removeMeteringPoint(i)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </div>

                        <mat-error *ngIf="invertersForm.hasError('mainCountInvalid')">
                            {{'Exactly one metering point must be marked as Main.' | translate}}
                        </mat-error>
                    </div>
                </div>

            </div>
            <div>
                <button mat-stroked-button type="button" (click)="onCancel()">{{'Cancel' | translate}}</button>

                <button mat-flat-button color="primary" class="daxa" type="button" (click)="submitUpdate()"
                    [disabled]="saving || invertersForm.invalid">
                    {{ saving ? ('Saving…' | translate) : ('Update_inverter' | translate) }}
                </button>
            </div>
        </form>
    </div>
</mat-card>